
import "../Divider/Divider.st.css.js";
import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_182_0_SidebarDividerNext";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_182_0_SidebarDividerNext__root","fullWidth":"wds_1_182_0_SidebarDividerNext__fullWidth","divider":"wds_1_182_0_SidebarDividerNext__divider"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {"sidebarWidth":"228px","backgroundColor":"#42454C"}; 
export var vars = {}; 




